export const permissions = {
  CandidateJobs: {
    Read: 'candidateJobs:read',
    Write: 'candidateJobs:write',
    ManualUpload: 'candidateJobs:manualUpload',
  },
  CandidateFeedbacks: {
    Read: 'candidateFeedbacks:read',
    Write: 'candidateFeedbacks:write',
  },
  CandidateAssessments: {
    Read: 'candidateAssessments:read',
  },
  Candidates: {
    Read: 'candidates:read',
  },
  Messaging: {
    Read: 'messaging:read',
    Write: 'messaging:write',
  },
  Companies: {
    Read: 'companies:read',
    Create: 'companies:create',
    Update: 'companies:update',
    Delete: 'companies:delete',
  },
  Files: {
    Read: 'files:read',
    Write: 'files:write',
  },
  Jobs: {
    Read: 'jobs:read',
    Create: 'jobs:create',
    Update: 'jobs:update',
    UpdateAiDisclosure: 'jobs:updateAiDisclosure',
    Delete: 'jobs:delete',
    StartSourcing: 'jobs:startSourcing',
    ContinueSourcing: 'jobs:continueSourcing',
  },
  UserExternalAccounts: {
    Read: 'userExternalAccounts:read',
    Write: 'userExternalAccounts:write',
  },
  SlackNotificationChannel: {
    Read: 'slack-notification-channel:read',
    Write: 'slack-notification-channel:write',
  },
  Users: {
    Read: 'users:read',
    Create: 'users:create',
    Update: 'users:update',
    Delete: 'users:delete',
  },
  Inbound: {
    Manage: 'inbound:manage',
  },
  Administration: {
    All: 'administration:all',
  },
} as const;

export type Permission =
  | (typeof permissions.CandidateJobs)[keyof typeof permissions.CandidateJobs]
  | (typeof permissions.CandidateFeedbacks)[keyof typeof permissions.CandidateFeedbacks]
  | (typeof permissions.CandidateAssessments)[keyof typeof permissions.CandidateAssessments]
  | (typeof permissions.Candidates)[keyof typeof permissions.Candidates]
  | (typeof permissions.Messaging)[keyof typeof permissions.Messaging]
  | (typeof permissions.Companies)[keyof typeof permissions.Companies]
  | (typeof permissions.Files)[keyof typeof permissions.Files]
  | (typeof permissions.Jobs)[keyof typeof permissions.Jobs]
  | (typeof permissions.UserExternalAccounts)[keyof typeof permissions.UserExternalAccounts]
  | (typeof permissions.SlackNotificationChannel)[keyof typeof permissions.SlackNotificationChannel]
  | (typeof permissions.Users)[keyof typeof permissions.Users]
  | (typeof permissions.Inbound)[keyof typeof permissions.Inbound]
  | (typeof permissions.Administration)[keyof typeof permissions.Administration];
